<template>
  <BasePage :pageTitle="__DICT__.passengerView.resort" show-menu show-footer>
    <Card margin="" body-class="p-0">
      <div class="list-group list-group-flush">
        <button
            v-for="resort in resorts"
            :key="resort.id"
            @click="selectResort(resort)"
            class="list-group-item list-group-item-action"
            :class="{ 'active': selectedResort === resort }"
        >
          {{ resort.name }}
        </button>
      </div>
    </Card>
  </BasePage>
</template>

<script setup>
import BasePage from "@/components/BasePage.vue";
import { useRouter } from "vue-router";
import { api } from "@/services/api.js";
import { ref, onMounted } from "vue";
import { Card } from "@/components/atomic";

const router = useRouter();
const resorts = ref([]);
const selectedResort = ref(null);

const selectResort = (resort) => {
  selectedResort.value = resort;
  router.push(`/resort/${resort.id}`);
};

onMounted(async () => {
  try {
    const response = await api.get('/api/resort');
    resorts.value = response;
  } catch (error) {
    console.error('Failed to fetch resorts:', error);
  }
});
</script>